import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '..';
import { IManagementUserInfoResModel } from '../../util/Request/requestType';

interface IUserModel {
    user: string | null
    isAuthenticate: boolean
    userInfo?: IManagementUserInfoResModel
    userFirstName?: string
}

const token = localStorage.getItem('accessToken');

const initialState: IUserModel = {
    user: null,
    isAuthenticate: token ? true : false,
};

export const soilUserSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        login: (state, action: PayloadAction<IUserModel>) => {
            const {
                user,
                isAuthenticate
            } = action.payload;
            return {
                user,
                isAuthenticate
            };
        },
        updateUserInfo: (state, action: PayloadAction<IManagementUserInfoResModel>) => {
            return {
                ...state,
                userInfo: action.payload
            };
        },
        updateAuthenticateState: (state, action: PayloadAction<boolean>) => {
            return {
                ...state,
                isAuthenticate: action.payload
            };
        },
        updateFirstName: (state, action: PayloadAction<string>) => {
            return {
                ...state,
                userFirstName: action.payload
            };
        },
    }
});

export type {
    IUserModel
};

export const {
    login,
    updateUserInfo,
    updateAuthenticateState,
    updateFirstName
} = soilUserSlice.actions;

export const selectSoilUser = (state: RootState) => state.soilUser;

export default soilUserSlice.reducer;